import { useState } from 'react';
import Button from '../Button';
import Item from './Item';

const DEFAULT_VIEWED = 3;

const Body = ({ items, selected }) => {
  const [showAll, setShowAll] = useState(false);

  const ctaTextNumber = items.length - DEFAULT_VIEWED;
  const ctaText = showAll ? (
    <>Hide Accessories</>
  ) : ctaTextNumber === 1 ? (
    <>1 More Accessory Available</>
  ) : ctaTextNumber > 1 ? (
    <>{ctaTextNumber} More Accessories Available</>
  ) : null;

  const toggleUpsellItems = () => setShowAll((prevState) => !prevState);

  return (
    <div className='tw:md:px-4'>
      <div>
        {items.slice(0, showAll ? items.length : DEFAULT_VIEWED).map((item) => (
          <Item key={item.itemId} item={item} isSelected={selected.find((i) => i.itemId === item.itemId)} />
        ))}
      </div>

      {!!ctaText && (
        <div className='tw:py-3 tw:text-center'>
          <Button variant='link' size='sm' onClick={toggleUpsellItems}>
            {ctaText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Body;
